module.exports = __webpack_public_path__ + "img/icons_UI_pause.4c9a1ef8.svg";